import React from "react";

const OpportunitySelect = () => {
	return <div>OpportunitySelect</div>;
};

export default OpportunitySelect;
